import Bugsnag from "@bugsnag/js";
import { ThunkAction } from 'redux-thunk';

import { storeSession, deleteSession } from '_utils/login';

import { SystemAction } from './types';
import { logIn, logOut } from './actions';
import { RootState } from '_store';
import { User } from "_types/system";

export type SystemThunk = ThunkAction<void, RootState, undefined, SystemAction>;

export const beginSession = (user: User, keepSignedIn: boolean): SystemThunk =>
  dispatch => {
    storeSession(user, keepSignedIn);
    Bugsnag.setUser(user.manufacturer.companyName, undefined, user.staffName);
    dispatch(logIn(user));
  };

export const endSession = (): SystemThunk => 
  dispatch => {
    deleteSession()
    dispatch(logOut())
  };
